<div class="container">
    <div class="">
        <img src="/assets/img/payFailure.gif" alt="">
    </div>

    <div class="Failure-text">You are payment has been declined</div>
</div>